import React, { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import { useGame } from "../contexts/GameContext";
import "../App.css";

const LeaguesRanking = () => {
  const { game } = useGame();
  const [leagues, setLeagues] = useState([]);

  useEffect(() => {
    async function fetchLeagues() {
      const leaguesSnapshot = await getDocs(collection(db, "leagues"));
      const leaguesList = leaguesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      // Sort by totalPoints (highest first)
      setLeagues(leaguesList.sort((a, b) => b.totalPoints - a.totalPoints));
    }
    fetchLeagues();
  }, []);

  if (!game) return <p>Loading game data...</p>;

  return (
    <div className="homepage-container" style={{ backgroundImage: `url(${game.cover})`, backgroundSize: "cover" }}>
      <div className="event-logo-container">
        <img src={game.logo} alt={game.name} className="event-logo" />
      </div>
      
      <div className="page-container"       
        style={{ 
        backgroundColor: "rgba(255, 255, 255, 1)", 
        padding: "0px", 
        borderRadius: "10px",
        marginTop: "20px",
        color: "black",
         }}>
        <h2>Leagues Ranking</h2>
        <table className="ranking-table"
        style={{
          width: "100%",
          textAlign: "center",
          margin: "20px",
        }}
        >
          <thead>
            <tr>
              <th>Rank</th>
              <th>League Name</th>
              <th>Total Points</th>
            </tr>
          </thead>
          <tbody>
            {leagues.map((league, index) => (
              <tr key={league.id}>
                <td>{index + 1}</td>
                <td>{league.name}</td>
                <td>{league.totalPoints}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeaguesRanking;